(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[346],{

/***/ 8618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./deckgo-qrcode.entry.js": [
		1227,
		227
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8618;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QF": function() { return /* reexport */ CardProduct; },
  "QJ": function() { return /* reexport */ CardProfile; },
  "Ub": function() { return /* reexport */ ContactUs; },
  "aB": function() { return /* reexport */ CreditCard; },
  "JI": function() { return /* reexport */ EditProfile; },
  "$_": function() { return /* reexport */ Footer; },
  "et": function() { return /* reexport */ InfoExtra; },
  "wp": function() { return /* reexport */ components_Navbar; },
  "dO": function() { return /* reexport */ components_NavbarUser; },
  "bX": function() { return /* reexport */ ReceiptPdf; },
  "YE": function() { return /* reexport */ Sidebar; },
  "iR": function() { return /* reexport */ Slider; },
  "$j": function() { return /* reexport */ Spinner; },
  "rf": function() { return /* reexport */ UserLayout/* default */.Z; }
});

// UNUSED EXPORTS: Header, Section, Separator

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Navbar.tsx
/* eslint-disable no-nested-ternary */ 


const links = [
    {
        name: "HOME",
        path: "/"
    },
    {
        name: "PASOS",
        id: "steps"
    },
    {
        name: "CON\xd3CENOS",
        id: "about"
    },
    {
        name: "CONT\xc1CTANOS",
        id: "contact"
    },
    {
        name: "REGISTRARSE",
        path: "/sign-up"
    },
    {
        name: "INGRESAR",
        path: "/sign-in"
    }
];
function Navbar(param) {
    let { image  } = param;
    const [isOpen, setOpen] = react.useState(false);
    const toggler = react.useRef(null);
    const navbar = react.useRef(null);
    const toggle = (e)=>{
        e.preventDefault();
        if (isOpen === false) {
            var _toggler_current, _navbar_current, _navbar_current_classList, _toggler_current1, _toggler_current_classList, _toggler_current2, _toggler_current_classList1;
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current = toggler.current) === null || _toggler_current === void 0 ? void 0 : _toggler_current.setAttribute("aria-expanded", "true");
            navbar === null || navbar === void 0 ? void 0 : (_navbar_current = navbar.current) === null || _navbar_current === void 0 ? void 0 : (_navbar_current_classList = _navbar_current.classList) === null || _navbar_current_classList === void 0 ? void 0 : _navbar_current_classList.add("show");
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current1 = toggler.current) === null || _toggler_current1 === void 0 ? void 0 : (_toggler_current_classList = _toggler_current1.classList) === null || _toggler_current_classList === void 0 ? void 0 : _toggler_current_classList.remove("collapsed");
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current2 = toggler.current) === null || _toggler_current2 === void 0 ? void 0 : (_toggler_current_classList1 = _toggler_current2.classList) === null || _toggler_current_classList1 === void 0 ? void 0 : _toggler_current_classList1.add("active");
            setOpen(true);
        } else {
            var _toggler_current3, _toggler_current4, _toggler_current_classList2, _toggler_current5, _toggler_current_classList3, _navbar_current1, _navbar_current_classList1;
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current3 = toggler.current) === null || _toggler_current3 === void 0 ? void 0 : _toggler_current3.setAttribute("aria-expanded", "false");
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current4 = toggler.current) === null || _toggler_current4 === void 0 ? void 0 : (_toggler_current_classList2 = _toggler_current4.classList) === null || _toggler_current_classList2 === void 0 ? void 0 : _toggler_current_classList2.remove("active");
            toggler === null || toggler === void 0 ? void 0 : (_toggler_current5 = toggler.current) === null || _toggler_current5 === void 0 ? void 0 : (_toggler_current_classList3 = _toggler_current5.classList) === null || _toggler_current_classList3 === void 0 ? void 0 : _toggler_current_classList3.add("collapsed");
            navbar === null || navbar === void 0 ? void 0 : (_navbar_current1 = navbar.current) === null || _navbar_current1 === void 0 ? void 0 : (_navbar_current_classList1 = _navbar_current1.classList) === null || _navbar_current_classList1 === void 0 ? void 0 : _navbar_current_classList1.remove("show");
            setOpen(false);
        }
    };
    const closeNavbar = (e)=>{
        document.getElementById("toggler").setAttribute("aria-expanded", "false");
        document.getElementById("toggler").classList.remove("active");
        document.getElementById("toggler").classList.add("collapsed");
        document.getElementById("navbar").classList.remove("show");
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navbar-area",
        id: "navigation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: "navbar navbar-expand-lg",
                        style: {
                            height: 110
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "navbar-brand",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: image,
                                        alt: "logo",
                                        className: "logo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "navbar-toggler collapsed",
                                        type: "button",
                                        "data-toggle": "collapse",
                                        "data-target": "#navbar",
                                        "aria-controls": "navbar",
                                        "aria-label": "toggle navigation",
                                        "aria-expanded": "false",
                                        onClick: toggle,
                                        id: "toggler",
                                        ref: toggler,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "toggler-icon",
                                                style: {
                                                    color: "white"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "toggler-icon",
                                                style: {
                                                    color: "white"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "toggler-icon",
                                                style: {
                                                    color: "white"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "navbar-collapse sub-menu-bar collapse",
                                id: "navbar",
                                ref: navbar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "navbar-nav ml-auto",
                                    id: "nav",
                                    children: links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "nav-item",
                                            children: link.path ? link.name === "INGRESAR" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.path,
                                                className: "page-scroll px-4",
                                                style: {
                                                    color: "#DAA520",
                                                    border: "0.16rem solid #DAA520"
                                                },
                                                children: link.name
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.path,
                                                className: "page-scroll",
                                                style: {
                                                    color: "white"
                                                },
                                                children: link.name
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/#".concat(link.id),
                                                className: "page-scroll",
                                                style: {
                                                    color: "white"
                                                },
                                                children: link.name
                                            })
                                        }, link.name))
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* harmony default export */ var components_Navbar = (Navbar);

;// CONCATENATED MODULE: ./components/Footer.tsx


function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "footer",
        style: {
            backgroundColor: "#17181d",
            paddingBottom: "2rem",
            width: "auto",
            height: "auto",
            paddingTop: "1rem"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "copyright pull-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "text-white",
                    children: "\xa9 ".concat(new Date().getFullYear(), " HMundo Group, Desarrollado por Avila Tek")
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/Section.tsx


function Section(param) {
    let { text , img , section  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: section,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6",
                    children: /*#__PURE__*/ _jsx("h5", {
                        className: "text-center",
                        children: text
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(6455);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./node_modules/firebase/storage/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(1153);
// EXTERNAL MODULE: ./node_modules/firebase/database/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(6256);
// EXTERNAL MODULE: ./lib/firebase.ts + 1 modules
var firebase = __webpack_require__(7818);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(9550);
;// CONCATENATED MODULE: ./components/CardProfile.tsx
/* eslint-disable @next/next/no-img-element */ 






function CardProfile(param) {
    let { user  } = param;
    const [, setUser] = (0,hooks/* useUser */.aF)();
    const uploadImage = ()=>{
        const inputClick = document.getElementById("uploadImage");
        inputClick.click();
    };
    const onChange = async (e)=>{
        var _e_target, _e_target_files;
        var _e_target_files_;
        const file = (_e_target_files_ = e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_files = _e_target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null;
        if (file) {
            const result = await (0,index_esm/* uploadBytes */.KV)((0,index_esm/* ref */.iH)(firebase/* storage */.tO, "userPhotos/".concat(encodeURIComponent(file.name))), file);
            const url = await (0,index_esm/* getDownloadURL */.Jt)(result.ref);
            await (0,dist_index_esm/* update */.Vx)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "users/".concat(user === null || user === void 0 ? void 0 : user.idUser)), {
                photo: url
            });
            setUser((_user)=>({
                    ..._user,
                    photo: url
                }));
            sweetalert2_all_default().fire({
                icon: "success",
                text: "Los cambios se han aplicado correctamente"
            });
        }
    };
    var _user_firstName_toLocaleUpperCase, _user_firstLastname_toLocaleUpperCase, _user_points_toLocaleString;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card card-user",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://res.cloudinary.com/dckoavcwj/image/upload/v1556306972/Bella_Bianco_100x100_pza.jpg",
                    alt: "fondo de carta de perfil"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "author",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: uploadImage,
                            role: "button",
                            "aria-hidden": "true",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (user === null || user === void 0 ? void 0 : user.photo) && (user === null || user === void 0 ? void 0 : user.photo) !== "" ? user === null || user === void 0 ? void 0 : user.photo : "../../assets/img/faces/face-profile.jpg",
                                style: {
                                    width: "150px",
                                    height: "150px",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                },
                                alt: "imagen de perfil",
                                id: "imageProfile"
                            })
                        }, "upload"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "file",
                            style: {
                                display: "none"
                            },
                            id: "uploadImage",
                            name: "uploadImage",
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "card-title",
                            style: {
                                marginTop: 17
                            },
                            children: [
                                (_user_firstName_toLocaleUpperCase = user === null || user === void 0 ? void 0 : user.firstName.toLocaleUpperCase()) !== null && _user_firstName_toLocaleUpperCase !== void 0 ? _user_firstName_toLocaleUpperCase : "",
                                " ",
                                (_user_firstLastname_toLocaleUpperCase = user === null || user === void 0 ? void 0 : user.firstLastname.toLocaleUpperCase()) !== null && _user_firstLastname_toLocaleUpperCase !== void 0 ? _user_firstLastname_toLocaleUpperCase : ""
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-footer py-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-5 offset-md-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Habitat Coins:",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: (_user_points_toLocaleString = user === null || user === void 0 ? void 0 : user.points.toLocaleString("es-ES")) !== null && _user_points_toLocaleString !== void 0 ? _user_points_toLocaleString : ""
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(3750);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
;// CONCATENATED MODULE: ./components/Sidebar.tsx
/* eslint-disable @next/next/no-img-element */ 






function Sidebar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sidebar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sidebar-wrapper ps ps--active-y",
            id: "sidebar",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sidebar-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/img/logo-marketplace.png",
                            alt: "logo",
                            style: {
                                width: 170,
                                height: 50,
                                alignContent: "center"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "nav",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/products",
                                style: {
                                    color: "white",
                                    fontSize: "17px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiFillShop */.ZWD, {
                                            style: {
                                                color: "white"
                                            }
                                        })
                                    }),
                                    "Market Place"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/user/exchanges",
                                style: {
                                    color: "white",
                                    fontSize: "17px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaExchangeAlt */.qau, {
                                            style: {
                                                color: "white"
                                            }
                                        })
                                    }),
                                    "Transacciones"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/user/exchange",
                                style: {
                                    color: "white",
                                    fontSize: "17px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdFileUpload */.s_P, {
                                            style: {
                                                color: "white"
                                            }
                                        })
                                    }),
                                    "Solicitud de Habitat Coins"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/user/request",
                                style: {
                                    color: "white",
                                    fontSize: "17px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegCheckSquare */.UUc, {
                                            style: {
                                                color: "white"
                                            }
                                        })
                                    }),
                                    "Status de Habitat Coins"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/user",
                                style: {
                                    color: "white",
                                    fontSize: "17px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            padding: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsFillPersonFill */.HHm, {
                                            style: {
                                                color: "white"
                                            }
                                        })
                                    }),
                                    "Perfil"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "footer-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                        className: "text-white m-auto text-center",
                        style: {
                            fontSize: "0.7rem"
                        },
                        children: [
                            "\xa9 ".concat(new Date().getFullYear(), " HMundo Group, Desarrollado por"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://avilatek.com",
                                children: "Avila Tek"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/EditProfile.tsx







function EditProfile() {
    const router = (0,next_router.useRouter)();
    const [user] = (0,hooks/* useUser */.aF)();
    const [phone, setPhone] = react.useState("");
    const datosPersonales = react.useMemo(()=>{
        return [
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.firstName,
                    type: "text",
                    className: "form-control",
                    name: "first_name",
                    disabled: true
                },
                label: "Primer nombre"
            },
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.secondName,
                    type: "text",
                    className: "form-control",
                    name: "second_name",
                    disabled: true
                },
                label: "Segundo nombre"
            },
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.firstLastname,
                    type: "text",
                    className: "form-control",
                    name: "last_name",
                    disabled: true
                },
                label: "Primer apellido"
            },
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.secondName,
                    type: "text",
                    className: "form-control",
                    name: "secondlast_name",
                    disabled: true
                },
                label: "Segundo apellido"
            },
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.dni,
                    type: "text",
                    className: "form-control",
                    name: "dni",
                    disabled: true
                },
                label: "C\xe9dula"
            },
            {
                className: "col-md-6",
                input: {
                    placeholder: user === null || user === void 0 ? void 0 : user.phone,
                    type: "text",
                    className: "form-control",
                    name: "number_phone",
                    disabled: false
                },
                label: "N\xfamero de tel\xe9fono"
            }
        ];
    }, [
        user
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // eslint-disable-next-line prefer-regex-literals
        const regex2 = new RegExp("^[0-9]*$");
        if (regex2.test(phone) && phone.length === 11) {
            await (0,dist_index_esm/* update */.Vx)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "users/".concat(user === null || user === void 0 ? void 0 : user.idUser)), {
                phone
            });
            await sweetalert2_all_default().fire({
                icon: "success",
                text: "Los cambios se han aplicado correctamente"
            });
            router.reload();
        } else {
            sweetalert2_all_default().fire({
                icon: "error",
                text: "Los datos suministrado estan erroneos"
            });
        }
    };
    const onChange = (e)=>{
        e.preventDefault();
        const { name , value  } = e.currentTarget;
        switch(name){
            case "number_phone":
                setPhone(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-header text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: "Editar el perfil"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    method: "POST",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: datosPersonales.map((dato)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: dato.className,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: dato.input.name,
                                                children: dato.label
                                            }),
                                            dato.input.disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: dato.input.type,
                                                placeholder: dato.input.placeholder,
                                                className: dato.input.className,
                                                name: dato.input.name,
                                                id: dato.input.name,
                                                disabled: true
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: dato.input.type,
                                                placeholder: dato.input.placeholder,
                                                className: dato.input.className,
                                                name: dato.input.name,
                                                onChange: onChange,
                                                id: dato.input.name,
                                                required: true
                                            })
                                        ]
                                    })
                                }, dato.label))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card-footer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-sm-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "btn btn-default btn-fill mb-2",
                                            onClick: handleSubmit,
                                            style: {
                                                float: "right"
                                            },
                                            children: "Enviar"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Spinner.tsx


function Spinner(param) {
    let { text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lds-roller",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                style: {
                    marginTop: "5px"
                },
                children: text
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Header.tsx


function Header() {
    return /*#__PURE__*/ _jsx("header", {
        className: "header-area",
        children: /*#__PURE__*/ _jsx("div", {
            id: "Header",
            className: "header-hero bg_cover",
            children: /*#__PURE__*/ _jsx("div", {
                className: "container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "header-hero-content text-left",
                            style: {
                                marginTop: "70px"
                            },
                            children: /*#__PURE__*/ _jsx("h2", {
                                className: "header-title text-white",
                                style: {
                                    borderLeft: "0.5rem solid white",
                                    paddingLeft: "1rem"
                                },
                                children: "TEXTO QUE RESUMA Y LA FUNCION Y MOTIVE A LOS USUARIOS A REGISTRARSE O INGRESAR EN LA PLATAFORMA"
                            })
                        })
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/Separator.tsx
/* eslint-disable @next/next/no-img-element */ 

function Separator() {
    return /*#__PURE__*/ _jsx("div", {
        className: "container",
        children: /*#__PURE__*/ _jsx("div", {
            className: "row justify-content-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "separator-container",
                id: "separator-container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "separator line-separator",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/assets/img/separator.png",
                        alt: "separator"
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 3 modules
var auth_dist_index_esm = __webpack_require__(708);
;// CONCATENATED MODULE: ./components/NavbarUser.tsx
/* eslint-disable @next/next/no-img-element */ 







function NavbarUser() {
    const router = (0,next_router.useRouter)();
    const [user, setUser] = (0,hooks/* useUser */.aF)();
    const [isOpen, setOpen] = react.useState(false);
    const navbar = react.useRef(null);
    const togglerUser = react.useRef(null);
    const onClick = async (e)=>{
        e.preventDefault();
        (0,auth_dist_index_esm/* signOut */.w7)(firebase/* auth */.I8);
        setUser(null);
        await router.push("/sign-in");
    };
    const toggle = (e)=>{
        e.preventDefault();
        if (isOpen === false) {
            var _togglerUser_current, _navbar_current, _navbar_current_classList, _togglerUser_current1, _togglerUser_current_classList, _togglerUser_current2, _togglerUser_current_classList1;
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current = togglerUser.current) === null || _togglerUser_current === void 0 ? void 0 : _togglerUser_current.setAttribute("aria-expanded", "true");
            navbar === null || navbar === void 0 ? void 0 : (_navbar_current = navbar.current) === null || _navbar_current === void 0 ? void 0 : (_navbar_current_classList = _navbar_current.classList) === null || _navbar_current_classList === void 0 ? void 0 : _navbar_current_classList.add("show");
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current1 = togglerUser.current) === null || _togglerUser_current1 === void 0 ? void 0 : (_togglerUser_current_classList = _togglerUser_current1.classList) === null || _togglerUser_current_classList === void 0 ? void 0 : _togglerUser_current_classList.remove("collapsed");
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current2 = togglerUser.current) === null || _togglerUser_current2 === void 0 ? void 0 : (_togglerUser_current_classList1 = _togglerUser_current2.classList) === null || _togglerUser_current_classList1 === void 0 ? void 0 : _togglerUser_current_classList1.add("active");
            setOpen(true);
        } else {
            var _togglerUser_current3, _togglerUser_current4, _togglerUser_current_classList2, _togglerUser_current5, _togglerUser_current_classList3, _navbar_current1, _navbar_current_classList1;
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current3 = togglerUser.current) === null || _togglerUser_current3 === void 0 ? void 0 : _togglerUser_current3.setAttribute("aria-expanded", "false");
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current4 = togglerUser.current) === null || _togglerUser_current4 === void 0 ? void 0 : (_togglerUser_current_classList2 = _togglerUser_current4.classList) === null || _togglerUser_current_classList2 === void 0 ? void 0 : _togglerUser_current_classList2.remove("active");
            togglerUser === null || togglerUser === void 0 ? void 0 : (_togglerUser_current5 = togglerUser.current) === null || _togglerUser_current5 === void 0 ? void 0 : (_togglerUser_current_classList3 = _togglerUser_current5.classList) === null || _togglerUser_current_classList3 === void 0 ? void 0 : _togglerUser_current_classList3.add("collapsed");
            navbar === null || navbar === void 0 ? void 0 : (_navbar_current1 = navbar.current) === null || _navbar_current1 === void 0 ? void 0 : (_navbar_current_classList1 = _navbar_current1.classList) === null || _navbar_current_classList1 === void 0 ? void 0 : _navbar_current_classList1.remove("show");
            setOpen(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "navbar navbar-default",
        id: "navbar_user",
        style: {
            backgroundColor: "#fdfdfd"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navbar-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        style: {
                            marginTop: "10px",
                            color: "white"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/img/habitat-coins-black.png",
                                alt: "Habitat coins",
                                style: {
                                    height: "1.5rem",
                                    width: "1.5rem",
                                    marginLeft: "1rem"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                style: {
                                    marginLeft: "1rem",
                                    color: "black"
                                },
                                children: user === null || user === void 0 ? void 0 : user.points.toLocaleString("es-ES")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "navbar-toggler collapsed",
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#navbar",
                    "aria-controls": "navbar",
                    "aria-label": "toggle navigation",
                    "aria-expanded": "false",
                    onClick: toggle,
                    id: "togglerUser",
                    ref: togglerUser,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "toggler-icon",
                            style: {
                                backgroundColor: "black"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "toggler-icon",
                            style: {
                                backgroundColor: "black"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "toggler-icon",
                            style: {
                                backgroundColor: "black"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "collapse navbar-collapse",
                    id: "navbar",
                    ref: navbar,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/user",
                                    style: {
                                        color: "white"
                                    },
                                    children: "Perfil"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/user/exchange",
                                    style: {
                                        color: "white"
                                    },
                                    children: "Canjear"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/user/request",
                                    style: {
                                        color: "white"
                                    },
                                    children: "Solicitudes"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/products",
                                    style: {
                                        color: "white"
                                    },
                                    children: "Productos"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: onClick,
                                    style: {
                                        color: "white"
                                    },
                                    role: "button",
                                    tabIndex: 0,
                                    onKeyDown: (e)=>{
                                        e.preventDefault();
                                    },
                                    children: "Salir"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    role: "button",
                    onClick: onClick,
                    style: {
                        color: "black",
                        right: "30px"
                    },
                    id: "logout",
                    tabIndex: 0,
                    onKeyDown: (e)=>{
                        e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaSignOutAlt */.fHX, {
                                style: {
                                    color: "black",
                                    marginRight: "0.5rem"
                                }
                            })
                        }),
                        "Salir"
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var components_NavbarUser = (NavbarUser);

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
;// CONCATENATED MODULE: ./lib/constants.ts
const EMAIL_TYPES = {
    FORM_SUBMIT: "form-submit",
    CHANGE_PASSWORD: "change-password",
    NEW_ACCOUNT: "new-account-employee",
    PRODUCT_DELIVERY: "product-delivery",
    COINS_SUBTRACTED: "coins-subtracted",
    COINS_APPROVED: "coins-approved",
    COINS_REJECTED: "coins-rejected",
    COINS_ADDED: "coins-added",
    TRANSACTION: "transaction",
    REDEEM_PRODUCT: "redeem-product"
};
const USER_TYPES = {
    TEAM: 1,
    EMPLOYEE: 2,
    ALLY: 3
};

;// CONCATENATED MODULE: ./components/CardProduct.tsx
/* eslint-disable @next/next/no-img-element */ 








function CardProduct(param) {
    let { product  } = param;
    var _product_categories;
    const router = (0,next_router.useRouter)();
    const [user] = (0,hooks/* useUser */.aF)();
    const [, setProduct] = (0,hooks/* useProduct */.iB)();
    const [coinsTeam, setCoinsTeam] = react.useState(0);
    const date = new Date();
    let quantity = 1;
    react.useEffect(function syncCoins() {
        const query = async ()=>{
            const snapshot = await (0,dist_index_esm/* get */.U2)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "habitatTeamAmount"));
            if (snapshot.exists()) {
                var _snapshot_val;
                setCoinsTeam((_snapshot_val = snapshot.val()) !== null && _snapshot_val !== void 0 ? _snapshot_val : 0);
            }
        };
        query();
    }, []);
    const onClick = async (e)=>{
        try {
            e.preventDefault();
            if (user.points < product.points) {
                sweetalert2_all_default().fire({
                    icon: "error",
                    title: "Error",
                    text: "No tiene los puntos suficientes para canjear este producto"
                });
                return;
            }
            const result = await sweetalert2_all_default().fire({
                title: "Estas seguro?",
                text: "desea canjear este producto?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, canjear"
            });
            if (result.value) {
                const results = await sweetalert2_all_default().fire({
                    title: "Indique la cantidad que desea canjear del producto",
                    input: "number",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    showLoaderOnConfirm: true,
                    preConfirm: (cantidad)=>{
                        if (cantidad > 0) {
                            quantity = cantidad;
                        } else {
                            sweetalert2_all_default().fire({
                                icon: "error",
                                title: "Error",
                                text: "El numero ingresado debe ser mayor a 1"
                            });
                            return null;
                        }
                        return quantity;
                    },
                    allowOutsideClick: ()=>!sweetalert2_all_default().isLoading()
                });
                var _product_points;
                const productCoins = quantity * ((_product_points = product === null || product === void 0 ? void 0 : product.points) !== null && _product_points !== void 0 ? _product_points : 0);
                if (results.value && (user === null || user === void 0 ? void 0 : user.points) >= productCoins) {
                    sweetalert2_all_default().fire({
                        icon: "success",
                        text: "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.firstLastname, ", el producto ha sido canjeado exitosamente")
                    });
                    let _codigo = "";
                    const caracteres = "0123456789";
                    for(let i = 0; i < 6; i += 1){
                        const number = Math.random();
                        var _caracteres_length;
                        const rand = Math.floor(number * ((_caracteres_length = caracteres === null || caracteres === void 0 ? void 0 : caracteres.length) !== null && _caracteres_length !== void 0 ? _caracteres_length : 0));
                        _codigo += caracteres.substring(rand, rand + 1);
                    }
                    const pointsNow = user.points - productCoins;
                    setProduct({
                        idProduct: null,
                        image: product.image,
                        title: product.title,
                        description: product.description,
                        points: productCoins,
                        numberExchange: _codigo,
                        categories: product.categories
                    });
                    (0,dist_index_esm/* push */.VF)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "exchanges"), {
                        id_user: user === null || user === void 0 ? void 0 : user.id,
                        product: product.title,
                        points: productCoins,
                        date: "".concat(date.getDate(), "/").concat(date.getMonth() + 1, "/").concat(date.getFullYear()),
                        number_exchange: date.getFullYear() + _codigo,
                        quantity
                    });
                    const coinsTeamUpdate = coinsTeam + productCoins;
                    await (0,dist_index_esm/* set */.t8)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "habitatTeamAmount"), coinsTeamUpdate);
                    await (0,dist_index_esm/* update */.Vx)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "users/".concat(user === null || user === void 0 ? void 0 : user.idUser)), {
                        points: pointsNow
                    });
                    var _user_firstName, _product_title;
                    const { data: { success  }  } = await axios/* default.post */.Z.post("/api/send-email", {
                        template: EMAIL_TYPES.REDEEM_PRODUCT,
                        client: (_user_firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user_firstName !== void 0 ? _user_firstName : "",
                        product: (_product_title = product === null || product === void 0 ? void 0 : product.title) !== null && _product_title !== void 0 ? _product_title : "",
                        email: user.email
                    });
                    if (success) {
                        await router.push("/products/receipt");
                    }
                } else {
                    sweetalert2_all_default().fire({
                        icon: "error",
                        title: "Error",
                        text: "No tiene los puntos suficientes para canjear la cantidad que establecio para este producto"
                    });
                }
            }
        } catch (err) {
            console.log(err);
            sweetalert2_all_default().fire({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error al intentar canjear este producto"
            });
        }
    };
    var _val_label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        id: "products",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: product === null || product === void 0 ? void 0 : product.image,
                    alt: "product_".concat(product === null || product === void 0 ? void 0 : product.title),
                    style: {
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px"
                    },
                    className: "card-img-top"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "text-center",
                            children: product.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bootstrap-tagsinput",
                                children: product === null || product === void 0 ? void 0 : (_product_categories = product.categories) === null || _product_categories === void 0 ? void 0 : _product_categories.map((val)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                                        className: "tag label label-info",
                                        children: (_val_label = val === null || val === void 0 ? void 0 : val.label) !== null && _val_label !== void 0 ? _val_label : "No hay categoria"
                                    }, val.value);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                className: "text-center py-3",
                                children: [
                                    "Habitat Coins: ",
                                    Number(product.points).toLocaleString("de-DE")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-default",
                                style: {
                                    float: "right"
                                },
                                onClick: onClick,
                                type: "button",
                                children: "Canjear"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@react-pdf/renderer/lib/react-pdf.browser.es.js + 13 modules
var react_pdf_browser_es = __webpack_require__(3775);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/ReceiptPDF.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 




function ReceiptPdf(param) {
    let { product , user  } = param;
    const date = new Date();
    const sello = react.useMemo(()=>"../../assets/img/HcoinsBlack.png", []);
    const logo = react.useMemo(()=>"../../assets/img/logo-marketplace-black.png.png", []);
    const dni = react.useMemo(()=>{
        return Number(user === null || user === void 0 ? void 0 : user.dni);
    }, [
        user === null || user === void 0 ? void 0 : user.dni
    ]);
    var _product_title, _user_firstName, _user_firstLastname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: user && product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* PDFViewer */.Z$, {
            style: {
                width: "100%",
                height: "500px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* Document */.BB, {
                title: "constancia_".concat(user === null || user === void 0 ? void 0 : user.firstName, "_").concat(product === null || product === void 0 ? void 0 : product.title),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_pdf_browser_es/* Page */.T3, {
                    wrap: false,
                    size: "A4",
                    style: {
                        paddingTop: 35,
                        paddingHorizontal: 35,
                        borderBottom: 1000,
                        borderBottomColor: "black"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            style: {
                                textAlign: "right",
                                fontSize: 10,
                                marginTop: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_pdf_browser_es/* Text */.xv, {
                                children: [
                                    "N\xb0 Confirmacion: ",
                                    date.getFullYear(),
                                    product === null || product === void 0 ? void 0 : product.numberExchange
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            style: {
                                width: 150,
                                height: 50,
                                marginVertical: 30,
                                position: "relative",
                                left: 191,
                                top: 20
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* Image */.Ee, {
                                src: logo,
                                fixed: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            style: {
                                textAlign: "center",
                                fontSize: 15,
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* Text */.xv, {
                                children: "Constancia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            style: {
                                margin: 15,
                                fontSize: 15,
                                textAlign: "justify"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_pdf_browser_es/* Text */.xv, {
                                children: [
                                    "Por medio de esta constancia, se hace validez el canjeo del producto: ",
                                    (_product_title = product === null || product === void 0 ? void 0 : product.title) !== null && _product_title !== void 0 ? _product_title : "",
                                    "por el usuario: ",
                                    (_user_firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user_firstName !== void 0 ? _user_firstName : "",
                                    " ",
                                    (_user_firstLastname = user === null || user === void 0 ? void 0 : user.firstLastname) !== null && _user_firstLastname !== void 0 ? _user_firstLastname : "",
                                    ", con la cedula",
                                    " ",
                                    dni.toLocaleString("es-ES")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* Image */.Ee, {
                                src: sello,
                                style: {
                                    width: 100,
                                    height: 100,
                                    alignContent: "center",
                                    left: 220,
                                    position: "relative",
                                    top: 50
                                },
                                fixed: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* View */.G7, {
                            style: {
                                textAlign: "center",
                                marginTop: 160,
                                fontSize: 13,
                                color: "grey",
                                left: 8
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_pdf_browser_es/* Text */.xv, {
                                children: dayjs_min_default()(date).format("DD/MM/YYYY HH:mm:ss")
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            style: {
                height: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        top: "300px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                        text: "Cargando..."
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/ExtraInfo.tsx






function InfoExtra() {
    const [user] = (0,hooks/* useUser */.aF)();
    const [instagram, setInstagram] = react.useState("");
    const [university, setUniversity] = react.useState("");
    const [contact, setContact] = react.useState("");
    const [productFav, setProductFav] = react.useState("");
    const [products, setProducts] = react.useState([]);
    const [infoEvents, setInfoEvents] = react.useState("Si");
    const [projects, setProjects] = react.useState("Si");
    const [arqDis, setArqDis] = react.useState("Si");
    const [fiscalData, setFiscalData] = react.useState("");
    const [locationWork, setLocationWork] = react.useState("");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        (0,dist_index_esm/* push */.VF)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "users/".concat(user.idUser, "/infoExtra")), {
            instagram,
            university,
            contact,
            productFav,
            infoEvents,
            projects,
            fundacionArdDis: arqDis,
            fiscalData,
            locationWork
        });
        await sweetalert2_all_default().fire({
            position: "top-end",
            text: "Tus datos se han enviado",
            showConfirmButton: false,
            timer: 1500
        });
        (0,dist_index_esm/* update */.Vx)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "users/".concat(user.idUser)), {
            answer: true
        });
    };
    const handleChange = (e)=>{
        const { name , value  } = e.currentTarget;
        switch(name){
            case "instagram":
                setInstagram(value);
                break;
            case "university":
                setUniversity(value);
                break;
            case "share_contact":
                setContact(value);
                break;
            case "product_fav":
                setProductFav(value);
                break;
            case "info_events":
                setInfoEvents(value);
                break;
            case "arq_dis":
                setArqDis(value);
                break;
            case "fiscal_company":
                setFiscalData(value);
                break;
            case "know_projects":
                setProjects(value);
                break;
            case "location_work":
                setLocationWork(value);
                break;
            default:
                break;
        }
    };
    react.useEffect(function syncProducts() {
        const _products = [];
        const unsubscribe = (0,dist_index_esm/* onValue */.jM)((0,dist_index_esm/* ref */.iH)(firebase/* database */.Fs, "products"), (snapshot)=>{
            if (snapshot.exists()) {
                snapshot.forEach((snap)=>{
                    _products.push(snap.val());
                });
            }
            var _products_sort;
            setProducts((_products_sort = _products === null || _products === void 0 ? void 0 : _products.sort((a, b)=>a.name > b.name ? -1 : 1)) !== null && _products_sort !== void 0 ? _products_sort : []);
        });
        return ()=>{
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-header text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: "Preguntas extras"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "instagram",
                                                children: "Instagram"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                placeholder: "@habitatpoints",
                                                className: "form-control",
                                                name: "instagram",
                                                onChange: handleChange,
                                                id: "instagram",
                                                required: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "university",
                                                children: "Lugar de estudio"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                placeholder: "Universidad Central",
                                                className: "form-control",
                                                name: "university",
                                                onChange: handleChange,
                                                id: "university",
                                                required: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "share_contact",
                                                children: "Donde habias oido hablar de nuestra marca:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                placeholder: "",
                                                className: "form-control",
                                                name: "share_contact",
                                                onChange: handleChange,
                                                id: "share_contact",
                                                required: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "product_fav",
                                                children: "Producto favorito de nuestra marca:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                name: "product_fav",
                                                id: "product",
                                                className: "form-control",
                                                onChange: handleChange,
                                                required: true,
                                                children: products.map((product)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: product.name,
                                                        children: product.name
                                                    }, product.name))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "info_events",
                                                children: "Le gustaria informarse sobre eventos patrocinados por Habitat Venezuela"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                name: "info_events",
                                                id: "info_events",
                                                className: "form-control",
                                                onChange: handleChange,
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "si",
                                                        children: "Si"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "no",
                                                        children: "No"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "know_project",
                                                children: "Conoces sobre nuestros proyectos de apoyo al turismo y la educacion"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                name: "know_project",
                                                id: "know_project",
                                                className: "form-control",
                                                onChange: handleChange,
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "si",
                                                        children: "Si"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "no",
                                                        children: "No"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "arq_dis",
                                                children: "Conoces sobre nuestro plan de fidelizacion y recocimiento para arquitectos y disenadores"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                name: "arq_dis",
                                                id: "arq_dis",
                                                className: "form-control",
                                                onChange: handleChange,
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "si",
                                                        children: "Si"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "no",
                                                        children: "No"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "fiscal_company",
                                                children: "Rif / C.I"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                name: "fiscal_company",
                                                className: "form-control",
                                                onChange: handleChange,
                                                id: "fiscal_company",
                                                required: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "location_work",
                                                children: "Cuidad y Zona de oficina"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                name: "location_work",
                                                placeholder: "Caracas",
                                                className: "form-control",
                                                onChange: handleChange,
                                                id: "location_work",
                                                required: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-default",
                            style: {
                                float: "right"
                            },
                            type: "submit",
                            children: "Enviar"
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/avilatek-utils/dist/avilatek-utils.esm.js
var avilatek_utils_esm = __webpack_require__(3628);
;// CONCATENATED MODULE: ./components/ContactUs.tsx






function ContactUs() {
    const [name, setName] = react.useState("");
    const [email, setEmail] = react.useState("");
    const [message, setMessage] = react.useState("");
    const [profession, setProfession] = react.useState("Ingeniero");
    const handleChange = (e)=>{
        const { name: _name , value  } = e.currentTarget;
        switch(_name){
            case "email":
                setEmail(value);
                break;
            case "profession":
                setProfession(value);
                break;
            case "message":
                setMessage(value);
                break;
            case "name":
                setName(value);
                break;
            default:
                break;
        }
    };
    const handleSubmit = async (e)=>{
        try {
            e.preventDefault();
            var _name_length;
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(name) && ((_name_length = name === null || name === void 0 ? void 0 : name.length) !== null && _name_length !== void 0 ? _name_length : 0) > 128) {
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "warning",
                    text: "Por favor, ingrese un valor para el campo nombre",
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }
            var _email_length;
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(email) && ((_email_length = email === null || email === void 0 ? void 0 : email.length) !== null && _email_length !== void 0 ? _email_length : 0) > 128) {
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "warning",
                    text: "Por favor, ingrese un valor para el campo correo",
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }
            var _message_length;
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(message) && ((_message_length = message === null || message === void 0 ? void 0 : message.length) !== null && _message_length !== void 0 ? _message_length : 0) > 2048) {
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "warning",
                    text: "Por favor, ingrese un valor para el campo mensaje",
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }
            var _profession_length;
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(profession) && ((_profession_length = profession === null || profession === void 0 ? void 0 : profession.length) !== null && _profession_length !== void 0 ? _profession_length : 0) > 128) {
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "warning",
                    text: "Por favor, ingrese un valor para el campo profesi\xf3n",
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }
            const { data: { success  }  } = await axios/* default.post */.Z.post("/api/send-email", {
                template: EMAIL_TYPES.FORM_SUBMIT,
                name,
                email,
                message,
                profession
            });
            if (success) {
                setEmail("");
                setMessage("");
                setName("");
                setProfession("Ingeniero");
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "success",
                    text: "Su mensaje ha sido enviado con exito",
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                sweetalert2_all_default().fire({
                    position: "top-end",
                    icon: "warning",
                    text: "Ha ocurrido un error al envia su mensaje",
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        } catch (err) {
            sweetalert2_all_default().fire({
                position: "top-end",
                icon: "warning",
                text: "Ha ocurrido un error al envia su mensaje",
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container h-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "section-title text-center pb-30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title text-white",
                            children: "Cont\xe1ctanos"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit,
                method: "POST",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        id: "input-contact",
                                        placeholder: "NOMBRE",
                                        className: "form-control",
                                        value: name,
                                        onChange: handleChange,
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        id: "input-contact",
                                        placeholder: "EMAIL",
                                        className: "form-control",
                                        value: email,
                                        onChange: handleChange,
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "profession",
                                        id: "input-contact",
                                        className: "form-control",
                                        placeholder: "PROFESION",
                                        onChange: handleChange,
                                        value: profession,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Arquitecto",
                                                children: "Arquitecto"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Dise\xf1ador",
                                                children: "Disenador"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Ingeniero",
                                                children: "Ingeniero"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Otro",
                                                children: "Otro"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 h-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form-group",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    name: "message",
                                    id: "input-contact",
                                    rows: 8,
                                    className: "form-control",
                                    placeholder: "MENSAJE",
                                    value: message,
                                    onChange: handleChange
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-fill btn-wd mb-2 w-25 mt-5",
                                    style: {
                                        backgroundColor: "#DAA520"
                                    },
                                    children: "ENVIAR"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@deckdeckgo/qrcode/dist/loader/index.js + 2 modules
var loader = __webpack_require__(6194);
;// CONCATENATED MODULE: ./components/CreditCard.tsx
/* eslint-disable @next/next/no-img-element */ 


function CreditCard(param) {
    let { name , lastName: lastname , email  } = param;
    const qrRef = react.useRef(null);
    react.useEffect(()=>{
        if (qrRef.current) {
            qrRef.current.innerHTML = '\n    <deckgo-qrcode content="https://habitat-points-admin.now.sh/selling_points/point_of_sell?email='.concat(email, '" style="position:relative;left:30px;width:100px;heigth:100px;">\n    </deckgo-qrcode>');
        }
    }, [
        email
    ]);
    react.useEffect(()=>{
        let windowMounted = false;
        if (!windowMounted) {
            (0,loader/* applyPolyfills */.m)().then(()=>{
                (0,loader/* defineCustomElements */.q)(window);
            });
        }
        return ()=>{
            windowMounted = true;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cards",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                id: "card1",
                className: "more",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "front",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "card__front-square card__square",
                                        src: "https://image.ibb.co/cZeFjx/little_square.png",
                                        alt: "chip_creditcard"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "card__front-logo card__logo",
                                        src: "https://habitat-venezuela.now.sh/assets/img/habitat/logo/logoHabitat.png",
                                        alt: "Logohabitat"
                                    }),
                                    "I",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontSize: "1rem"
                                        },
                                        id: "email_creditcard",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                style: {
                                                    color: "white"
                                                },
                                                children: [
                                                    "******",
                                                    email.slice(email.indexOf("@") - 3, email.indexOf("com") + 3)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "card1",
                                        className: "button",
                                        "aria-hidden": "true",
                                        children: "Codigo QR"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card__space-75",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "card__label text-white",
                                        children: "Due\xf1o"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "card__info",
                                        children: [
                                            name,
                                            " ",
                                            lastname
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card__black-line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12",
                                        id: "qr",
                                        ref: qrRef
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "card1",
                                    className: "button return",
                                    "aria-hidden": "true",
                                    children: "Volver"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/layout/UserLayout.tsx
var UserLayout = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(3387);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/wrap.mjs
var wrap = __webpack_require__(5755);
;// CONCATENATED MODULE: ./components/Slider.tsx
// eslint-disable-next-line no-use-before-define




const variants = {
    enter: (direction)=>({
            x: direction > 0 ? 100 : -100,
            opacity: 0,
            zIndex: 0
        }),
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction)=>({
            zIndex: 0,
            x: direction < 0 ? 100 : -100,
            opacity: 0
        })
};
const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity)=>Math.abs(offset) * velocity;
function Slider(param) {
    let { images =[] , controls =false  } = param;
    const [[page, direction], setPage] = react.useState([
        0,
        0
    ]);
    var _images_length;
    const imageIndex = (0,wrap/* wrap */.r)(0, (_images_length = images === null || images === void 0 ? void 0 : images.length) !== null && _images_length !== void 0 ? _images_length : 0, page);
    const paginate = react.useCallback((newDirection)=>{
        setPage([
            page + newDirection,
            newDirection
        ]);
    }, [
        page
    ]);
    const timeout = react.useRef(null);
    react.useEffect(function autoMove() {
        const SLIDE_TIME = 5 * 1000; // 15s in ms
        const id = setInterval(()=>{
            paginate(1);
        }, SLIDE_TIME);
        timeout.current = id;
        return ()=>{
            if (timeout.current) {
                clearInterval(timeout.current);
            }
        };
    }, [
        paginate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        style: {
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "item-center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            custom: direction,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "Header",
                    className: "header-hero bg_cover",
                    style: {
                        position: "absolute",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header-hero-content text-left",
                                    style: {
                                        marginTop: "70px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "header-title text-white",
                                        style: {
                                            borderLeft: "0.5rem solid white",
                                            paddingLeft: "1rem"
                                        },
                                        id: "texto-banner",
                                        children: [
                                            "Bienvenido al Market Place de Habitat Venezuela.",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-white py-3",
                                                style: {
                                                    fontSize: "1.5rem"
                                                },
                                                id: "parrafor-banner",
                                                children: "Un espacio virtual dise\xf1ado para nuestros clientes. Registrando tus compras en esta plataforma, acumular\xe1s Habitat Coins que podr\xe1n ser canjeados por productos o servicios especiales. Queremos dar un trato especial a quien m\xe1s se lo merece. Solo debes registrarte y seguir los pasos #PisandoFirme"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                    className: "imgBanner",
                    style: {
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        alignContent: "center"
                    },
                    src: images[imageIndex],
                    custom: direction,
                    variants: variants,
                    animate: "center",
                    transition: {
                        x: {
                            type: "spring",
                            stiffness: 350,
                            damping: 50,
                            duration: 0.1
                        },
                        opacity: 0.1
                    },
                    drag: "x",
                    dragConstraints: {
                        left: 0,
                        right: 0
                    },
                    dragElastic: 1,
                    onDragEnd: ()=>{
                        const swipe = swipePower(10, 10);
                        if (swipe < -swipeConfidenceThreshold) {
                            paginate(1);
                        } else if (swipe > swipeConfidenceThreshold) {
                            paginate(-1);
                        }
                    }
                }, page)
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/index.tsx



















/***/ }),

/***/ 8701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(748);



function UserLayout(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "wrapper",
        id: "body",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* .Sidebar */ .YE, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "main-panel ps ps--active-y",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* .NavbarUser */ .dO, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container-fluid",
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* .Footer */ .$_, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h0": function() { return /* reexport */ usePagination; },
  "iB": function() { return /* reexport */ useProduct; },
  "aF": function() { return /* reexport */ useUser; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/index.tsx
var context = __webpack_require__(7975);
;// CONCATENATED MODULE: ./hooks/useProduct.ts


function useProduct() {
    const { product , setProduct  } = (0,react.useContext)(context/* AppContext */.I);
    return [
        product,
        setProduct
    ];
}

;// CONCATENATED MODULE: ./hooks/usePagination.ts

function usePagination(items) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        currentPage: 1,
        perPage: 6
    };
    var _config_currentPage;
    const [currentPage, setCurrentPage] = (0,react.useState)((_config_currentPage = config === null || config === void 0 ? void 0 : config.currentPage) !== null && _config_currentPage !== void 0 ? _config_currentPage : 1);
    var _config_perPage;
    const [numberPerPage, setNumberPage] = (0,react.useState)((_config_perPage = config === null || config === void 0 ? void 0 : config.perPage) !== null && _config_perPage !== void 0 ? _config_perPage : 6);
    const [pageNumbers, setPageNumbers] = (0,react.useState)([]);
    const [idxOfLastItem, setIdxOfLastItem] = (0,react.useState)(currentPage * numberPerPage);
    const [idxOfFirstItem, setIdxOfFirstItem] = (0,react.useState)(idxOfLastItem - numberPerPage);
    var _items_slice;
    const currentItems = (_items_slice = items === null || items === void 0 ? void 0 : items.slice(idxOfFirstItem, idxOfLastItem)) !== null && _items_slice !== void 0 ? _items_slice : [];
    (0,react.useEffect)(()=>{
        setIdxOfLastItem(currentPage * numberPerPage);
    }, [
        currentPage,
        numberPerPage
    ]);
    (0,react.useEffect)(()=>{
        setIdxOfFirstItem(idxOfLastItem - numberPerPage);
    }, [
        idxOfLastItem,
        numberPerPage
    ]);
    (0,react.useEffect)(function calculatePageNumbers() {
        const pages = new Array(Math.ceil(items.length / numberPerPage)).fill(0);
        setPageNumbers(pages === null || pages === void 0 ? void 0 : pages.map((_, index)=>index + 1));
    }, [
        items === null || items === void 0 ? void 0 : items.length,
        numberPerPage
    ]);
    return {
        currentPage,
        setCurrentPage,
        numberPerPage,
        setNumberPage,
        pageNumbers,
        items: currentItems
    };
}

;// CONCATENATED MODULE: ./hooks/useUser.ts


function useUser() {
    const { user , setUser  } = (0,react.useContext)(context/* AppContext */.I);
    return [
        user,
        setUser
    ];
}

;// CONCATENATED MODULE: ./hooks/index.ts





/***/ }),

/***/ 2480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);